module.exports = __webpack_public_path__ + "media/backgrounds/arthur-hamilton-9Y1iOQ4rvtw-unsplash-15855d75.jpg";